export default __webpack_public_path__ + "static/media/landingpage.4b50578b.png";